import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAnalyticsFinancialYear } from '../../redux/actions/analyticsAction';

const FY_OPTIONS = [
    { label: 'FY 23-24', value: '2324' },
    { label: 'FY 24-25', value: '2425' },
    { label: 'FY 25-26', value: '2526' },
    { label: 'FY 26-27', value: '2627' },
];

const FYSelector = ({ onYearChange }) => {
    const dispatch = useDispatch();
    const { financialYear } = useSelector(state => state.analytics);

    const handleChange = (fy) => {
        dispatch(setAnalyticsFinancialYear(fy));
        if (onYearChange) onYearChange(fy);
    };

    return (
        <div className="d-flex gap-2 flex-wrap mb-3">
            {FY_OPTIONS.map(opt => (
                <button
                    key={opt.value}
                    onClick={() => handleChange(opt.value)}
                    className={`btn btn-sm fw-semibold ${financialYear === opt.value ? 'btn-primary' : 'btn-outline-secondary'}`}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
};

export default FYSelector;
